import { getWithToken, postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
const process = apiUrl + "/process";
const routes = {
  label: "Process",
  root: process,
  get_by_product_ids: process + "/get_by_product_ids",
  get_by_project_ids: process + "/get_by_project_ids",
  get_by_building_ids: process + "/get_by_building_ids",
  get_by_reused_product_id: process + "/get_by_reused_product_id",
  delete: process + "/delete",
  save: process + "/save",
};
export const Process = {
  get_by_product_ids: (ids) => postWithToken(routes.get_by_product_ids, { ids }),
  get_by_project_ids: (ids) => postWithToken(routes.get_by_project_ids, { ids }),
  get_by_building_ids: (ids) => postWithToken(routes.get_by_building_ids, { ids }),
  get_by_reused_product_id: (reused_product_id) => getWithToken(routes.get_by_reused_product_id, { reused_product_id }),
  save: (process_list) => postWithToken(routes.save, process_list),
  delete: (ids) => postWithToken(routes.delete, { ids }),
};
